export const isPreRelease = process.env.GATSBY_FLAG_PRE_RELEASE === 'true';
